export default __webpack_public_path__ + "media/hot-now2x.14ad2bc5.png";